.container {
  user-select: none;
}

.wrapper {
  margin: 1rem 0;
}

.row {
  display: grid;
  grid-template-columns: 2fr 2fr 1.5fr 1fr;
  gap: 1rem;
  padding: 0.75rem 0;
  border-bottom: 1px solid var(--color-neutral-200);
  align-items: center;
}

.row > * {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.header {
  font-weight: 500;
  font-size: 0.875rem;
  color: #666;
  border-bottom: 2px solid var(--color-neutral-200);
  padding-top: 0;
}

.modalFooter {
  gap: 1rem;
}
